import PropTypes from 'prop-types'
import { Fragment } from 'react'
import Link from 'next/link'

// Internal components
import Button from '../Button/Button'
import LazyImage from '../LazyImage/LazyImage'

const ArticleListItem = ({ url, cover, title }, index) => {
  const createMarkup = (copy) => ({ __html: copy })

  return (
    <Fragment key={`ArticleLIstItem-${index}`}>
      {cover[0].CoverFigureRight[0] && (
        <Link href={url}>
          <a className="ArticleListItem">
            {cover[0].CoverFigureRight.length && (
              <div className="ArticleListItem-image">
                <LazyImage
                  image={cover[0].CoverFigureRight[0].image}
                  sizes={'(min-width: 1100px) 460px, (min-width: 760px) 280px, 140px'}
                />
              </div>
            )}
            <div className="ArticleListItem-description" dangerouslySetInnerHTML={createMarkup(title)}></div>
          </a>
        </Link>
      )}
    </Fragment>
  )
}

const ArticleList = (props) => {
  const { articleListTitle, articleListCollection, optionalButton, modifiers } = props
  const modifierClasses = modifiers && modifiers.length ? ' ' + modifiers.join(' ') : ''

  return (
    <div className={`ArticleList${modifierClasses}`}>
      <div className="ArticleList-inner">
        {articleListTitle && <h3 className="ArticleList-title">{articleListTitle}</h3>}
        <div className="ArticleList-main">
          {articleListCollection && articleListCollection.map((link, index) => ArticleListItem(link, index))}
        </div>

        {optionalButton.length > 1 && (
          <div className="ArticleList-footer">
            <div className="ArticleList-buttonContainer">
              <Button
                href={optionalButton[0]?.button?.url}
                target={optionalButton[0]?.button?.target}
                label={optionalButton[0]?.button?.customText || optionalButton[0]?.button?.text}
                icon={{ id: 'icon-chevron-right' }}
                modifiers={['Button--articleList']}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

ArticleListItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  cover: PropTypes.array
}

ArticleList.propTypes = {
  title: PropTypes.string,
  articleListCollection: PropTypes.array,
  articleListTitle: PropTypes.string,
  modifiers: PropTypes.array,
  optionalButton: PropTypes.array
}

export default ArticleList
